import type { CommissionTransaction } from "@/lib/commission.api";
import type { Party } from "@/lib/party.api";
import type { CommissionViewMode } from "../commission.constants";
import { CommissionGrid } from "./CommissionGrid";
import { CommissionsTable } from "./CommissionsTable";

interface CommissionsContentProps {
  commissions: CommissionTransaction[];
  parties: Record<number, Party>;
  viewMode: CommissionViewMode;
  loading: boolean;
  canDelete: boolean;
  deletingId: number | null;
  typeLabel: (code: string) => string;
  onSelect: (commission: CommissionTransaction) => void;
  onReload: () => void;
  onDelete: (id: number) => void;
}

export function CommissionsContent({
  commissions,
  parties,
  viewMode,
  loading,
  canDelete,
  deletingId,
  typeLabel,
  onSelect,
  onReload,
  onDelete,
}: CommissionsContentProps) {
  if (viewMode === "grid") {
    return (
      <CommissionGrid
        commissions={commissions}
        parties={parties}
        canDelete={canDelete}
        deletingId={deletingId}
        typeLabel={typeLabel}
        onSelect={onSelect}
        onReload={onReload}
        onDelete={onDelete}
      />
    );
  }

  return (
    <CommissionsTable
      commissions={commissions}
      parties={parties}
      loading={loading}
      canDelete={canDelete}
      deletingId={deletingId}
      typeLabel={typeLabel}
      onSelect={onSelect}
      onReload={onReload}
      onDelete={onDelete}
    />
  );
}
